import failIcon from 'assets/img/icons/icon-warning.svg'
import PagePopopCloseButton from 'components/page-components/PagePopopCloseButton'

const ReceivedOfferFail = ({closeWindow}) => {
  return (
    <div className="modal-window__wrapper" onClick={(e) => e.stopPropagation()}>
      <PagePopopCloseButton close={closeWindow} />
      <header className="modal-window__header">
        <img src={failIcon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Sorry!</h5>
        <p className="modal-window__info">The transaction was not successful.</p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={closeWindow}>Done</button>
      </footer>
    </div>
  )
}

export default ReceivedOfferFail
